/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MenuSide } from "../../components/MenuSide";
import InputCustom from "../../components/InputCustom";
import ButtonCustom from "../../components/ButtonCustom";
import { TextareaAutosize } from "@mui/material";
import {
  tokenUsuario,
  urlAdicionarModelosMensagem,
} from "../../utils/constants";
import SelectCustom from "../../components/SelectCustom";

export default function AdicionarModelosMensagem() {
  const navigate = useNavigate();

  const [name, setName] = useState("daily_menu_text_only");
  const [language, setLanguage] = useState("en");
  const [category, setCategory] = useState("MARKETING");
  const [headerText, setHeaderText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [footerText, setFooterText] = useState(
    "Deseja continuar recebendo nosso cardápio?"
  );
  const [button1, setButton1] = useState("Não");
  const [button2, setButton2] = useState("Sim");

  const categorias = [
    { id: "MARKETING", name: "Marketing" },
    { id: "UTILITY", name: "Utilidade" },
    { id: "AUTHENTICATION", name: "Autenticação" },
  ];

  const adicionarInformacoes = async () => {
    try {
      const response = await axios.post(urlAdicionarModelosMensagem, {
        name: name,
        category: category,
        headerText: headerText,
        bodyText: bodyText,
        footerText: footerText,
        button1: button1,
        button2: button2,
        token: tokenUsuario,
      });

      if (response.data == 1) {
        navigate({ pathname: "/modelos" });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const gerarNomeCardapio = () => {
    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const ano = hoje.getFullYear();
    return `cardapioDoDia${dia}${mes}${ano}`;
  };

  const gerarHeaderMensagem = () => {
    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const ano = hoje.getFullYear();
    return `Cardápio do dia ${dia}/${mes}/${ano}`;
  };

  useEffect(() => {
    setName(gerarNomeCardapio());
    setHeaderText(gerarHeaderMensagem());
  }, []);

  return (
    <div className="row">
      <div className="col-sm-2">
        <MenuSide />
      </div>
      <div className="col-sm-10">
        <br />
        <div className="card" style={{ marginRight: "1%" }}>
          <div className="card-header">
            <div className="row">
              <div
                className="col-sm-3"
                style={{ fontWeight: 700, fontSize: "25px" }}
              >
                Adicionar Modelo de Mensagem
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-sm-6">
                <h6>Nome</h6>
                <InputCustom
                  value={name}
                  setValue={(event) => {
                    event.preventDefault();
                    setName(event.target.value);
                  }}
                  type="text"
                  placeHolder="Nome do modelo"
                />
              </div>
              <div className="col-sm-3">
                <h6>&nbsp;Categoria</h6>
                <SelectCustom
                  value={category}
                  setValue={(event) => {
                    setCategory(event.target.value);
                  }}
                  itens={categorias}
                  valueItem={"id"}
                  nameItem={"name"}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-12">
                <h6>Cabeçalho da mensagem</h6>
                <InputCustom
                  value={headerText}
                  setValue={(event) => {
                    event.preventDefault();
                    setHeaderText(event.target.value);
                  }}
                  type="text"
                  placeHolder="Cabeçalho da mensagem"
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-12">
                <h6>Corpo da mensagem</h6>
                <TextareaAutosize
                  value={bodyText}
                  onChange={(event) => {
                    event.preventDefault();
                    setBodyText(event.target.value);
                  }}
                  style={{
                    width: "100%",
                    borderRadius: "0.5rem",
                    marginTop: "4px",
                  }}
                  minRows={12}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-12">
                <h6>Rodapé da mensagem</h6>
                <InputCustom
                  value={footerText}
                  setValue={(event) => {
                    event.preventDefault();
                    setFooterText(event.target.value);
                  }}
                  type="text"
                  placeHolder="Rodapé da mensagem"
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-6">
                <h6>Botão 1</h6>
                <InputCustom
                  value={button1}
                  setValue={(event) => {
                    event.preventDefault();
                    setButton1(event.target.value);
                  }}
                  type="text"
                  placeHolder="Texto do botão 1"
                />
              </div>
              <div className="col-sm-6">
                <h6>Botão 2</h6>
                <InputCustom
                  value={button2}
                  setValue={(event) => {
                    event.preventDefault();
                    setButton2(event.target.value);
                  }}
                  type="text"
                  placeHolder="Texto do botão 2"
                />
              </div>
            </div>
          </div>

          <div className="card-footer text-end">
            <ButtonCustom
              onClick={adicionarInformacoes}
              color={"error"}
              texto={"Confirmar"}
              icon={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
